export enum DateFormats {
    DAY_MONTH_YEAR_WITH_SLASH = 'dd/MM/yyyy',
    DAY_MONTH_YEAR_WITH_HYPHEN = 'dd-MM-yyyy',
    YEAR_MONTH_DAY_WITH_HYPHEN = 'yyyy-MM-dd',
    YEAR_MONTH_DAY_WITH_SLASH = 'yyyy/MM/dd',
}